import {useState} from 'react';
import {useNavigate} from 'react-router-dom';
import Button from '../../../../../../components/button';
import CustomHeader from '../../../../../../components/mazraeKit/headers/homeHeader';
import PageLoader from '../../../../../../components/pageLoader';
import useGetCooperationAgreementDate from '../../../../../../services/hookService/getCooperationAgreementDate/useGetCooperationAgreementDate';
import {getPersianDateTime} from '../../../../../../utilities/helper/GetPersianDateTime';
import {
  isExpired,
  isWithinDaysOfExpiry,
} from '../../../../../../utilities/helper/isCloseToExpire';
import CancelAgreementBottomSheet from './CancelAgreementBottomSheet';
import SuccessTerminationRequestSendBottomSheet from './SuccessTerminationRequestSendBottomSheet';

const MyStorePartnershipAgreementLicense = () => {
  const navigate = useNavigate();

  const [openCancelAgreement, setOpenCancelAgreement] =
    useState<boolean>(false);
  const [openSuccessBottomSheet, setOpenSuccessBottomSheet] =
    useState<boolean>(false);

  const {data, isLoading: isAgreementDataLoading} =
    useGetCooperationAgreementDate();

  const shopName = 'شما';
  const agreementTile = `قرارداد مشارکت در فروش میان شرکت اینده پژوهان لوتوس و فروشگاه ${shopName} تا تاریخ ${getPersianDateTime(
    data?.end_date,
  )} معتبر هست.`;

  const isAgreementCloseToExpire = isWithinDaysOfExpiry(data?.end_date!, 7);
  const isAgreementExpired = isExpired(data?.end_date!);
  const isLoading = isAgreementDataLoading;

  if (isAgreementDataLoading) return <PageLoader />;

  const handleSubmit = () => {
    if (isAgreementExpired) window.location.replace('https://app.emzano.com');
    if (isAgreementCloseToExpire)
      navigate(
        '/my-store-sales-partnership-agreement/hasLicenseAgreement=false',
      );

    setOpenCancelAgreement(true);
  };

  const buttonTitle = () => {
    if (isAgreementExpired || isAgreementCloseToExpire) return 'امضا قرار داد';
    return 'درخواست فسخ قرارداد';
  };

  return (
    <main className="relative flex flex-col w-full overflow-y-auto h-dvh">
      <CustomHeader
        title={' قرارداد مشارکت در فروش '}
        preIcon="icon-nameArrow---Right ml-2"
        isActiveRightIcon
        justifyFlex="justify-start"
        sticky
      />

      <section className="flex flex-col h-full p-6">
        <h4 className="text-sm font-medium text-gray-800">
          قرارداد بین سامانه مزرعه و فروشگاه
        </h4>

        <span className="text-sm leading-4 text-gray-700 tracking-[0.5px] [word-spacing:3px]">
          {agreementTile}
        </span>

        {isAgreementCloseToExpire && (
          <div className="flex gap-2 mt-6 text-sm text-red-600">
            <i className="text-md icon-warning-triangle" />
            <span>
              تاریخ انقضای قرارداد شما نزدیک است. در صورت عدم امضای مجدد آن،
              قراردادتان باطل می‌شود.
            </span>
          </div>
        )}

        {isAgreementExpired && (
          <div className="flex gap-2 mt-6 text-sm text-red-600">
            <i className="text-md icon-warning-triangle" />
            <span>
              قرارداد شما به دلیل اتمام تاریخ انقضا، باطل شده است. برای مشارکت
              مجدد قرارداد را امضا کنید.
            </span>
          </div>
        )}

        {/* Sticky bottom button */}
        <div className="w-full px-2 mt-auto bg-white border-t border-gray-300">
          <Button
            onClick={handleSubmit}
            isLoading={isLoading}
            className="w-full disabled:opacity-50 disabled:bg-gray-400 disabled:text-white disabled:cursor-not-allowed"
          >
            {buttonTitle()}
          </Button>
        </div>
      </section>

      <CancelAgreementBottomSheet
        open={openCancelAgreement}
        setOpen={setOpenCancelAgreement}
        agreementGuid={data?.guid}
        onShowSuccessBottomSheet={() => setOpenSuccessBottomSheet(true)}
      />

      <SuccessTerminationRequestSendBottomSheet
        open={openSuccessBottomSheet}
        setOpen={setOpenSuccessBottomSheet}
      />
    </main>
  );
};

export default MyStorePartnershipAgreementLicense;
